import { StateProvider } from "contexts/ContextProvider";
import { Route, Routes } from "react-router-dom";
import VendorProfileCreateScreen from "screens/App/CRM/Contact/VendorProfile/VendorProfileCreateScreen";
import VendorProfileDetailScreen from "screens/App/CRM/Contact/VendorProfile/VendorProfileDetailScreen";
import VendorProfileEditScreen from "screens/App/CRM/Contact/VendorProfile/VendorProfileEditScreen";
import VendorProfileListScreen from "screens/App/CRM/Contact/VendorProfile/VendorProfileListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const VendorProfileRouter = () => {
  return (
    <StateProvider>
      <Routes>
        <Route path="create" element={<VendorProfileCreateScreen />} />
        <Route path=":id/detail" element={<VendorProfileDetailScreen />} />
        <Route path=":id/edit" element={<VendorProfileEditScreen />} />
        <Route path="list" element={<VendorProfileListScreen />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </StateProvider>
  );
};

export default VendorProfileRouter;
